import last from "lodash/last";

import type { Time } from "~/tools/date-time/time";
import { Impulse, type Scope } from "~/tools/impulse";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";

export type MonitorStatusDrawerTabType = "supporting-metrics" | "related-issues";

export interface CheckStateChainElement {
	identifier: string;
	showImpactedComponent: Impulse<boolean>;
	selectedTab: Impulse<undefined | MonitorStatusDrawerTabType>;
}

export class CheckStateChain {
	public static init(initial: CheckStateChainElement) {
		return new CheckStateChain(initial, Impulse([]));
	}

	private constructor(
		private readonly initial: CheckStateChainElement,
		private readonly chain: Impulse<ReadonlyArray<CheckStateChainElement>>,
	) {}

	public peek(scope: Scope): CheckStateChainElement {
		return this.chain.getValue(scope).at(-1) ?? this.initial;
	}

	public pop(): void {
		this.chain.setValue((chain) => chain.slice(0, -1));
	}

	public push(checkStateId: string): void {
		this.chain.setValue((chain) => {
			const latest = last(chain) ?? this.initial;

			return [
				...chain,

				// add next drawer state, should have the same initial state as the current one
				{
					identifier: checkStateId,
					showImpactedComponent: latest.showImpactedComponent.clone(),
					selectedTab: latest.selectedTab.clone(),
				},
			];
		});
	}

	public size(scope: Scope): number {
		return 1 + this.chain.getValue(scope).length;
	}
}

export interface MonitorStatusDrawerState {
	checkStateChain: CheckStateChain;
	timestamp: Impulse<Time>;
	timeRange: Impulse<TimeRange>;
}
